import { suppressEmotionFirstChildSelectorWarning } from '@/lib/styling/emotionFirstChildSelector';
import styled from '@emotion/styled';

const NoSectionContentMessage = styled('p')(({ theme }) => ({
  marginTop: 0,
  marginBottom: 12,
  color: theme.palette.text.secondary,
  fontStyle: 'italic',
  fontSize: 14,
  [`:last-child ${suppressEmotionFirstChildSelectorWarning}`]: {
    marginBottom: 0,
  },
}));

export default NoSectionContentMessage;
